const MUSIC_PREFERENCE_OPTIONS = ["1", "2", "3", "4", "5"];
const WEEK_RATING_OPTIONS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
const RETURN_NEXT_YEAR_OPTIONS = ["Yes", "No"];
const MORNING_GROUP_OPTIONS = [
  "VBS",
  "Middle School",
  "High School",
  "College",
  "Young Adults",
  "Adults",
];
const MORNING_SESSION_OPTIONS = [
  "I didn't enjoy it",
  "I wish we did something else",
  "I enjoyed it, but I'd change a few things",
  "I enjoyed my time (no complaints)",
  "I loved the morning sessions",
];
const INVITE_OPTIONS = [
  "Yes! More young families/kids",
  "Yes! More youth",
  "Yes! More adults",
  "No, no one comes to mind because all my friends are already here",
];
const LEADERSHIP_ROLES = [
  "Dorm Lead",
  "Team Lead",
  "LIT (Leader in Training)",
  "Youth Worship Team",
  "VBS Director(s)",
  "Middle School Speaker",
  "High School Speaker",
  "College Speaker",
  "Young Adult Speaker",
  "Adult Speaker",
  "Evangelist",
  "Evening Worship Team",
  "Missionary",
  "Service Host",
  "AV",
  "Kitchen Cook(s)",
  "Dining Hall Manager/Lead",
  "Morning Devotions",
  "Sideboard Manager",
  "Kids Activities Leader",
  "Youth Activities Leader",
  "Adults Activities Leader",
  "Registrar/Facilities",
  "Camp Nurse",
  "Nursery Leader",
];

export const SURVEY_SUCCESS_MESSAGE =
  "Thank you for the feedback! We would like to invite you to the all camp meeting Saturday 18th at 2:00pm, if you have any praises or concerns you'd like to vocally make known, this is your opportunity!";

export const initialSurveyState = {
  contactEmail: "",
  contactPhone: "",
  weekRating: "",
  returnNextYear: "",
  favoriteActivity: "",
  leastFavoriteActivity: "",
  activitySuggestions: "",
  counselorFeedback: "",
  speakerRecommendations: "",
  adultFeedback: "",
  parentFeedback: "",
  eveningEvangelistRequest: "",
  musicPreference: "",
  morningGroup: "",
  morningSessionEnjoyment: "",
  morningSessionExplanation: "",
  mealComments: "",
  accommodationsFeedback: "",
  overallSuggestions: "",
  inviteAudience: "",
  leadershipRoles: [],
  leadershipName: "",
  leadershipEmail: "",
  leadershipPhone: "",
  finalThoughts: "",
};

export function hasLeadershipInterest(formData) {
  return Array.isArray(formData.leadershipRoles) && formData.leadershipRoles.length > 0;
}

function hasValue(value) {
  return typeof value === "string" ? value.trim().length > 0 : Boolean(value);
}

function optionalEmailIsValid(value) {
  if (!hasValue(value)) return true;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
}

export function validateSurveyForm(formData) {
  const errors = {};

  if (!WEEK_RATING_OPTIONS.includes(String(formData.weekRating || ""))) {
    errors.weekRating = "Please rate your week at camp.";
  }

  if (!RETURN_NEXT_YEAR_OPTIONS.includes(formData.returnNextYear)) {
    errors.returnNextYear = "Please choose whether you hope to come back next year.";
  }

  [
    ["favoriteActivity", "Please share your favorite activity."],
    ["leastFavoriteActivity", "Please share your least favorite activity."],
    ["activitySuggestions", "Please share any activity suggestions for next year."],
    ["counselorFeedback", "Please share any feedback for counselors or volunteers."],
    ["speakerRecommendations", "Please share any speaker recommendations."],
    ["eveningEvangelistRequest", "Please share any evening evangelist requests."],
    ["morningSessionExplanation", "Please explain your morning session answer."],
    ["mealComments", "Please share comments or suggestions for meals."],
    ["accommodationsFeedback", "Please share your accommodations feedback."],
    ["overallSuggestions", "Please share suggestions for camp next year."],
    ["finalThoughts", "Please share any final complaints, praises, or thoughts."],
  ].forEach(([field, message]) => {
    if (!hasValue(formData[field])) {
      errors[field] = message;
    }
  });

  if (!MUSIC_PREFERENCE_OPTIONS.includes(String(formData.musicPreference || ""))) {
    errors.musicPreference = "Please choose your music preference.";
  }

  if (!MORNING_GROUP_OPTIONS.includes(formData.morningGroup)) {
    errors.morningGroup = "Please choose which group you were with.";
  }

  if (!MORNING_SESSION_OPTIONS.includes(formData.morningSessionEnjoyment)) {
    errors.morningSessionEnjoyment = "Please rate the morning session.";
  }

  if (!INVITE_OPTIONS.includes(formData.inviteAudience)) {
    errors.inviteAudience = "Please choose who you have in mind to invite.";
  }

  if (!optionalEmailIsValid(formData.contactEmail)) {
    errors.contactEmail = "Please enter a valid email address.";
  }

  if (hasLeadershipInterest(formData)) {
    if (!hasValue(formData.leadershipName)) {
      errors.leadershipName = "Name is required when you select a leadership role.";
    }
    if (!optionalEmailIsValid(formData.leadershipEmail)) {
      errors.leadershipEmail = "Please enter a valid leadership email address.";
    } else if (!hasValue(formData.leadershipEmail)) {
      errors.leadershipEmail = "Email is required when you select a leadership role.";
    }
    if (!hasValue(formData.leadershipPhone)) {
      errors.leadershipPhone = "Phone number is required when you select a leadership role.";
    }
  }

  return errors;
}

export {
  INVITE_OPTIONS,
  LEADERSHIP_ROLES,
  MORNING_GROUP_OPTIONS,
  MORNING_SESSION_OPTIONS,
  MUSIC_PREFERENCE_OPTIONS,
  RETURN_NEXT_YEAR_OPTIONS,
  WEEK_RATING_OPTIONS,
};
